import { Button, Form, Input, Spin, message } from 'antd';
import Cookies from 'js-cookie';
import _ from 'lodash';
import queryString from 'query-string';
import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { connect } from 'react-redux';
import { getDataAuth } from '../../redux/actions/auth.action';
import { resetMapLayer } from '../../redux/actions/map.action';
import { changeMenu, onResetLayerAll } from '../../redux/actions/menu.action';
import { reconnectSocket } from '../../redux/actions/socket.action';
import { LocalStore } from '../../utils/LocalStore';
import {
  AxiosGetSSOApi,
  AxiosGetSecretApi,
  AxiosPostSecretApi,
} from '../../utils/fetchApi';
import './login.scss';

const SITE_KEY = '6LciyiMaAAAAAOsmVRvw71-8K-VBns_iaBS-C8F0';
const AUTH_URL = 'https://dangnhapqa.danang.gov.vn';
const CLIENT_URL = 'https://gis-quyhoach.greenglobal.vn/dang-nhap';
const CAS_URL = '/cas/login';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: undefined,
      password: undefined,
      isEnableCapcha: false,
      capchaValue: undefined,
      query: {},
    };

    this.reCaptchaRef = React.createRef();
    this.form = React.createRef();
  }

  async componentDidMount() {
    const {
      location: { search },
    } = this.props;

    this.props.onResetLayerAll();
    this.props.changeMenu(false);
    this.props.resetMapLayer();
    localStorage.clear();
    message.config({
      getContainer: () => document.getElementById('login'),
    });
    await AxiosGetSecretApi('/api/users/form');
    if (!_.isEmpty(search)) {
      this.setState({
        query: queryString.parse(search),
      });
    }
  }

  // async componentDidUpdate(prevProps, prevState) {
  //   const { query } = this.state;
  //   if (prevState.query !== query) {
  //     const arrr = query.ticket.split('-');
  //     const url = `/serviceValidate?service=http://localhost:3000&ticket=${query.ticket}`;
  //     let response = await AxiosGetSSOApi(url, {
  //       headers: {
  //         isSSO: true,
  //       },
  //     });
  //     console.log(response);
  //   }
  // }

  async componentDidUpdate(prevProps, prevState) {
    const { query } = this.state;
    if (prevState.query !== query) {
      const arrr = query.ticket.split('-');
      // const url = `/serviceValidate?service=http://localhost:3000&ticket=${query.ticket}`;
      // let response = await AxiosGetSSOApi(url, {
      //   headers: {
      //     isSSO: true,
      //   },
      // });
      // console.log(response);
      // const REDIRECT_URI = 'https://gis-sxd-dn.greenglobal.com.vn/dang-nhap';
      const CLIENT_ID = 'default-client';

      const url = `/authorize?response_type=code&scope=openid&redirect_uri=${CLIENT_URL}&client_id=${CLIENT_ID}`;
      let response = await AxiosGetSSOApi(url, {
        headers: {
          isSSO: true,
        },
      });
      console.log(response);
    }
  }

  async handleSubmit() {
    this.setState({ isLoading: true });
    this.form.current
      .validateFields()
      .then((e) => {
        let data = {
          username: e.username,
          password: e.password,
          _csrf: Cookies.get('XSRF-TOKEN'),
        };
        if (this.state.isEnableCapcha) {
          data.capcha = this.state.capchaValue;
        }
        this.onLogin(data);
      })
      .catch(this.setState({ isLoading: false }));
  }

  async onLogin(data) {
    let res = await AxiosPostSecretApi('/api/users/sign-in', data);
    if (res.success) {
      LocalStore.getInstance().save('loginSession', res.token);
      LocalStore.getInstance().save('loginRole', res.role);

      // ----------------------------------
      LocalStore.getInstance().save('loginPermission', res.Permistion);
      LocalStore.getInstance().save('loginListRole', res.ListQuyen);
      LocalStore.getInstance().save('HoVaTen', res.HoVaTen);

      res.MaPhuongXa &&
        LocalStore.getInstance().save('loginMaPhuongXa', res.MaPhuongXa);

      // ----------------------------------

      LocalStore.getInstance().save('id', res.Id);
      this.props.reconnectSocket(true);
      this.props.getAuthData(res.Permistion);
      this.props.history.push('/');
    } else {
      message.error(res.err);
      if (
        this.reCaptchaRef.current &&
        this.reCaptchaRef.current.props &&
        this.reCaptchaRef.current.props.grecaptcha
      ) {
        this.reCaptchaRef.current.props.grecaptcha.reset();
      }
      this.setState({ capchaValue: null, isEnableCapcha: res.showCapcha });
    }
  }

  onLoginSSO() {
    // window.open(`${AUTH_URL}${CAS_URL}?service=${CLIENT_URL}`, '_self');
    window.open(`${AUTH_URL}${CAS_URL}?service=${CLIENT_URL}`, '_self');
  }

  render() {
    const { query } = this.state;

    return (
      <div className='login' id='login'>
        <div>
          <div className='header'>
            <div className='circle'>
              <div className='icon-img'></div>
            </div>
          </div>
          <div className='popup-login'>
            <div className='body'>
              <div className='title'>
                <div style={{ width: '600px' }}>
                  <div
                    style={{
                      color: '#206ECB',
                      fontSize: '26px',
                      lineHeight: '30.47px',
                    }}
                  >
                    HỆ THỐNG THÔNG TIN QUY HOẠCH - KIẾN TRÚC
                  </div>
                  <div
                    style={{
                      fontSize: '32px',
                      marginTop: '5px',
                      color: 'rgb(227,115,66)',
                    }}
                  >
                    THÀNH PHỐ ĐÀ NẴNG
                  </div>
                </div>
              </div>

              {_.isEmpty(query) ? (
                <div className='form-login'>
                  <Form
                    layout='vertical'
                    style={{ width: '406px' }}
                    ref={this.form}
                  >
                    <Form.Item
                      label={<div className='input-title'>Tên đăng nhập</div>}
                      name='username'
                      style={{ marginBottom: '20px' }}
                      initialValue={this.state.username}
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Vui lòng nhập tên đăng nhập!',
                        },
                      ]}
                    >
                      <Input
                        className='input'
                        prefix={
                          <i
                            className='far fa-user'
                            style={{ opacity: '0.5' }}
                          />
                        }
                      />
                    </Form.Item>

                    <Form.Item
                      label={<div className='input-title'>Mật khẩu</div>}
                      name='password'
                      style={{ marginBottom: '40px' }}
                      initialValue={this.state.password}
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Vui lòng nhập mật khẩu',
                        },
                      ]}
                    >
                      <Input.Password
                        className='input'
                        autoComplete='new-password'
                        prefix={
                          <i
                            className='fas fa-lock'
                            style={{
                              opacity: '0.5',
                              color: 'rgb(147,147,147)',
                            }}
                          />
                        }
                      />
                    </Form.Item>

                    {this.state.isEnableCapcha && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '15px',
                          marginBottom: '20px',
                        }}
                      >
                        <ReCAPTCHA
                          sitekey={SITE_KEY}
                          ref={this.reCaptchaRef}
                          onChange={(e) => {
                            this.setState({ capchaValue: e });
                          }}
                          hl='vi'
                        />
                      </div>
                    )}

                    <Form.Item>
                      <Button
                        type='primary'
                        htmlType='submit'
                        className='login-button'
                        style={{ marginBottom: '0px' }}
                        onClick={() => {
                          this.handleSubmit();
                        }}
                      >
                        Đăng nhập
                      </Button>
                    </Form.Item>

                    <Form.Item>
                      <Button
                        type='primary'
                        className='login-button'
                        style={{ marginBottom: '0px' }}
                        onClick={() => this.onLoginSSO()}
                      >
                        Đăng nhập SSO
                      </Button>
                    </Form.Item>

                    <Form.Item style={{ marginBottom: '0px' }}>
                      <Button
                        className='back-button'
                        onClick={() => {
                          this.props.history.push('/');
                        }}
                      >
                        Trở về
                      </Button>
                    </Form.Item>

                    {/* <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    className="back-button"
                    onClick={() => {
                      this.props.history.push("/");
                    }}
                  >
                    Trở về
                  </Button>
                </div> */}
                  </Form>
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '30px',
                  }}
                >
                  <Spin size='default'></Spin>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  reconnectSocket: reconnectSocket,
  getAuthData: getDataAuth,
  onResetLayerAll: onResetLayerAll,
  resetMapLayer: resetMapLayer,
  changeMenu: changeMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
